
import React, { Fragment, useState } from 'react';
import {
    ShowButton,
    SimpleShowLayout,
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    ShowController,
    Show,
    ShowView,
    SelectInput,
    SimpleForm,
    TextInput,
    Filter,
    FormDataConsumer,
    ArrayInput,
    SimpleFormIterator,
    ImageField,
    ArrayField,
    BooleanField,
    BooleanInput,
    ImageInput,
    SelectArrayInput,
    NumberInput,
    NumberField,
    ReferenceInput,
    AutocompleteInput,
    AutocompleteArrayInput,
    useNotify,
    Toolbar,
    SaveButton,
    ReferenceField,
    FileInput,
    FileField,
    SingleFieldList,
    FunctionField,
    DateField,
    DateInput,
    useRecordContext,
    DateTimeInput,
    TopToolbar,
    Button as RaButton,
    useRefresh,
    ReferenceArrayField,
    ReferenceArrayInput,
    ChipField,
    useGetList, useList, useListController, ListContextProvider,
    Labeled,
} from 'react-admin';

import {
    Divider, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField as MuiTextField,
    Button, Box, CircularProgress, Avatar, CardContent, CardActions, CardHeader, Card, Grid
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom'
import {getLoginToken, getSelectedProject} from '../common/common.js'

//Custom Import Start

//Custom Import End

const DraftTitle = () => {
    const record = useRecordContext();
    if (!record) return null;
    return <span>Draft</span>;
};

const EditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

const DraftFilter = props => (
    <Filter {...props}>
        <TextInput resettable label="id" source="id" alwaysOn />




        {
            //Custom Filter Start

            //Custom Filter End
        }
    </Filter>
);

export const DraftList = props => {
    const navigate = useNavigate()
    const refresh = useRefresh();

    //Custom List Code Start

    //Custom List Code End
    return (
        <List title="Package" {...props} filters={<DraftFilter />} mutationMode='optimistic'
            exporter={false}
            sort={{ field: 'id', order: 'DESC' }}
            perPage={30}
        >
            <Datagrid rowClick="show" bulkActionButtons={true}>
                <BooleanField label="Is Public" source="public" />
                
                <TextField label="ID" source="id" />
                
                <ReferenceField source="project_id" reference="project">
                    <TextField label="Project" source="name" />
                </ReferenceField>

                <ReferenceField source="project_id" reference="project">
                    <TextField label="Project" source="version" />
                </ReferenceField>
                
                <TextField label="Name" source="name" />
                
                <ReferenceField link="show" label="Sketch" source="sketch_udid" reference="sketch">
                    <TextField source="name" />
                </ReferenceField>

                <ReferenceField link="show" label="Member" source="member_no" reference="user">
                    <TextField source="email" />
                </ReferenceField>

                <ReferenceField link="edit" label="Preview" source="preview_start_screen_id" reference="screen" >
                    <TextField source="name" />
                </ReferenceField>

                <DateField label="Create Date" source="reg_date" />
                <DateField label="Update Date" source="update_date" />

                <EditButton label='Edit' />
            </Datagrid>
        </List>
    )
};

const required = (message = 'Required') =>
    value => value ? undefined : message;
const maxLength = (max, message = (max + '자 이하로 입력해주세요')) =>
    value => value && value.length > max ? message : undefined;
const validateName = [required(), maxLength(15)];
const validateRequire = [required()];


export const DraftCreate = props => (
    <Create title={<DraftTitle />} {...props} mutationMode='optimistic' redirect="list" >
        <SimpleForm toolbar={<EditToolbar />} >
            <TextInput resettable label="Draft Name" source="name" validate={validateRequire} />

            <TextInput resettable label="desc" source="desc" validate={validateRequire} fullWidth/>

            <BooleanInput label="Is Public" source="public" />

            <ReferenceInput source="sketch_udid" reference="sketch">
                <AutocompleteInput sx={{width:400}} label="Sketch" optionText="name" filter={{project_id:getSelectedProject()}}/>
            </ReferenceInput>

            <ReferenceInput source="preview_start_screen_id" reference="screen" filter={{project_id:getSelectedProject()}}>
                <AutocompleteInput sx={{width:400}} label="Preview Start Screen" optionText="name" />
            </ReferenceInput>

            <ArrayInput label="Screen List" source={'screen_list'} >
                <SimpleFormIterator>
                    <ReferenceInput source="screen_id" reference="screen" filter={{project_id:getSelectedProject()}}>
                        <AutocompleteInput sx={{width:400}} label="Screen" optionText="name" />
                    </ReferenceInput>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput label="Block List" source={'block_list'} >
                <SimpleFormIterator>
                    <ReferenceInput source="block_id" reference="block" filter={{project_id:getSelectedProject()}}>
                        <AutocompleteInput sx={{width:400}} label="block" optionText="name" />
                    </ReferenceInput>
                </SimpleFormIterator>
            </ArrayInput>

        </SimpleForm>
    </Create>
);

export const DraftEdit = props => (
    <Edit title={<DraftTitle />} {...props} mutationMode='optimistic' redirect="edit">
        <SimpleForm toolbar={<EditToolbar />} >
            <TextInput resettable label="Draft Name" source="name" validate={validateRequire} />

            <TextInput resettable label="desc" source="desc" validate={validateRequire} fullWidth/>
            
            <BooleanInput label="Is Public" source="public" />

            <ReferenceInput source="sketch_udid" reference="sketch">
                <AutocompleteInput sx={{width:400}} label="Sketch" optionText="name" filter={{project_id:getSelectedProject()}}/>
            </ReferenceInput>

            <ReferenceInput source="preview_start_screen_id" reference="screen" filter={{project_id:getSelectedProject()}}>
                <AutocompleteInput sx={{width:400}} label="Preview Start Screen" optionText="name" />
            </ReferenceInput>

            <ArrayInput label="Screen List" source={'screen_list'} >
                <SimpleFormIterator>
                    <ReferenceInput source="screen_id" reference="screen" filter={{project_id:getSelectedProject()}}>
                        <AutocompleteInput sx={{width:400}} label="Screen" optionText="name" />
                    </ReferenceInput>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput label="Block List" source={'block_list'} >
                <SimpleFormIterator >
                    <ReferenceInput source="block_id" reference="block" filter={{project_id:getSelectedProject()}}>
                        <AutocompleteInput sx={{width:400}} label="block" optionText="name" />
                    </ReferenceInput>
                </SimpleFormIterator>
            </ArrayInput>

        </SimpleForm>
    </Edit>
);

export const DraftShow = ({ ...props }) => {
    //Custom Show Init Start

    //Custom Show Init End
    return (
        <Show title={<DraftTitle />} {...props} >
            <SimpleShowLayout>
                <TextField label="ID" source="id" />
                <TextField label="Name" source="name" false />
                <ReferenceField link="show" label="Sketch" source="sketch_udid" reference="sketch">
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField link="show" label="Member" source="member_no" reference="user">
                    <TextField source="email" />
                </ReferenceField>

                <ReferenceField link="edit" label="Preview" source="preview_start_screen_id" reference="screen">
                    <TextField source="name" />
                </ReferenceField>
                
                <DateField label="Create Date" source="reg_date" />
                <DateField label="Update Date" source="update_date" />

                <ArrayField label="Screen List" source={'screen_list'} >
                    <Datagrid bulkActionButtons={false}>
                        <ReferenceField linkType='show' label="Screen Name" source="screen_id" reference="screen" sortable={false}>
                            <TextField label="Name" source="name" />
                        </ReferenceField>
                    </Datagrid>
                </ArrayField>

                <ArrayField label="Block List" source={'block_list'} >
                    <Datagrid bulkActionButtons={false}>
                        <ReferenceField linkType='show' label="Block Name" source="block_id" reference="block" sortable={false}>
                            <TextField label="Name" source="name" />
                        </ReferenceField>
                    </Datagrid>
                </ArrayField>
            </SimpleShowLayout>
        </Show>
    )
};
